module.exports = __webpack_public_path__ + "img/dislike-white.8753c6fb.svg";